import { Spinner } from "../../../../widgets";
import clsx from "clsx";
import { useGetPageMetadataQuery } from "../../../../services/data";

export const PageTitle = ({ pageId, label, className }: {
    pageId: string
    label: string
    className?: string
}) => {
    const { data: page, isLoading } = useGetPageMetadataQuery(pageId);

    return <>
        <div className="d-flex justify-content-center">
            <Spinner show={isLoading} />
        </div>

        {(page) && <div className={clsx(className, "d-flex gap-2 fs-8 align-items-center border bg-gray-400 rounded px-3 p-1 shadow-sm")}>
            <span className="fw-semibold fs-9">{label}:</span>
            <label className="fw-bold m-0 text-primary">{page.name}</label>
        </div>}
    </>
}

